import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import Alert from "react-s-alert";
import ImageZoom from "react-medium-image-zoom";

class CStatusModalSoal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user_nonaktif_reason : '',
            isLoadingBu : false
        }

        this.toggleModalSoal = this.toggleModalSoal.bind(this)
    }

    toggleModalSoal() {
        this.props.toggleModalSoal()
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.toggleModalSoal} className="modal-primary custom-dialog">
                <ModalHeader toggle={this.toggleModalSoal}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    <div className="form-group row">
                        <label className="col-lg-12 form-control-label">
                            {this.props.modalBodyText}
                        </label>
                    </div>
                    <div>
                        <table className="table table-striped table-bordered animated fadeIn">
                            <thead>
                            <tr>
                                <th width="50">No</th>
                                <th>Pertanyaan</th>
                                <th>Gambar</th>
                                <th width="150">Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.dataListSoal.map((item,i) => {
                                return (
                                    <tr key={item.question_id}>
                                        <td>{i+1}</td>
                                        <td><div dangerouslySetInnerHTML={{ __html: item.question_text.substring(0, 400) }} /></td>
                                        <td>
                                            {
                                                item.question_pict !== null ?
                                                    (
                                                        <ImageZoom
                                                            image={{
                                                                src: "data:"+item.qtype_pict+";base64,"+item.question_pict,
                                                                className: 'img',
                                                                style: { width: '15em' }
                                                            }}
                                                        />
                                                    ): (
                                                        <ImageZoom
                                                            image={{
                                                                src: "./noimage.gif",
                                                                className: 'img',
                                                                style: { width: '15em' }
                                                            }}
                                                        />
                                                    )
                                            }
                                        </td>
                                        <td>{item.question_type}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggleModalSoal}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

CStatusModalSoal.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModalSoal: PropTypes.func.isRequired,
    dataListSoal: PropTypes.string.dataListSoal
}

export default CStatusModalSoal


// WEBPACK FOOTER //
// ./src/components/CStatusModalSoal.js